import React from "react";
import UserReport from "../../components/UserReport/UserReport";

const ReportPage = (): React.ReactElement => <UserReport />;

export default ReportPage;
